(() => {
  'use strict';
  document.documentElement.classList.add('js');
  const root = window.Shopify?.routes?.root || '/';
  const status = document.getElementById('store-status');
  const drawer = document.getElementById('cart-drawer');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const closing = new WeakMap();
  let lastTrigger;
  let lastSync = Date.now();
  let refreshing;
  let cartRequests = 0;
  let desynced = false;
  const say = message => { if (status) status.textContent = message; };
  const identity = item => JSON.stringify([Number(item.id), Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)), Number(item.selling_plan_id || 0)]);
  const views = () => [...document.querySelectorAll('[data-cart-view]')];
  const readState = node => JSON.parse(node.querySelector('[data-cart-state]').textContent);
  let cart = document.querySelector('[data-cart-view]') ? readState(document.querySelector('[data-cart-view]')) : { items: [], item_count: 0, total_price: 0, currency: 'USD' };
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency || 'USD' }).format(cents / 100);
  const openDialog = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog?.showModal) return false;
    closing.get(dialog)?.cancel();
    closing.delete(dialog);
    dialog.classList.remove('is-closing');
    lastTrigger = trigger || document.activeElement;
    if (!dialog.open) {
      dialog.showModal();
      if (dialog === drawer && !reducedMotion.matches) dialog.animate([{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    return true;
  };
  const closeDialog = dialog => {
    if (!dialog?.open || closing.has(dialog)) return;
    if (dialog !== drawer || reducedMotion.matches) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    const animation = dialog.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(100%)' }], { duration: 220, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' });
    closing.set(dialog, animation);
    animation.finished.then(() => {
      if (closing.get(dialog) !== animation) return;
      dialog.close();
      animation.cancel();
      closing.delete(dialog);
      dialog.classList.remove('is-closing');
    }).catch(() => {});
  };
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => {
      const target = lastTrigger?.isConnected ? lastTrigger : document.querySelector('[data-open-cart]');
      target?.focus({ preventScroll: true });
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(dialog); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
  });
  const api = async (path, options = {}) => {
    cartRequests++; views().forEach(view => { view.dataset.cartRequests = cartRequests; });
    const response = await fetch(root + path, { credentials: 'same-origin', ...options });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Your bag could not be updated. Please try again.');
    return data;
  };
  const clearErrors = () => document.querySelectorAll('[data-cart-error]').forEach(el => el.replaceChildren());
  const showError = (message, recovery = false) => {
    document.querySelectorAll('[data-cart-error]').forEach(el => {
      el.textContent = message;
      if (recovery) {
        const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'Open your bag to review it.';
        el.append(' ', link);
      }
    });
    say(message);
  };
  const projection = () => {
    const quantities = new Map(cart.items.map(item => [identity(item), item.quantity]));
    const adds = [];
    for (const task of queue.operations) {
      if (task.kind === 'change') quantities.set(task.identity, task.quantity);
      else {
        const entry = task.payload;
        quantities.set(entry.identity, (quantities.get(entry.identity) || 0) + entry.quantity);
        adds.push(task);
      }
    }
    let total = cart.total_price;
    cart.items.forEach(item => { total += ((quantities.get(identity(item)) ?? item.quantity) - item.quantity) * item.final_price; });
    return { quantities, adds, count: [...quantities.values()].reduce((sum, value) => sum + value, 0), total: Math.max(0, total) };
  };
  const pendingNode = payload => {
    const node = document.createElement('article'); node.className = 'cart-item pending-add'; node.setAttribute('aria-label', 'Adding ' + payload.preview.title);
    const thumb = document.createElement('div'); thumb.className = 'cart-item-image';
    if (payload.preview.image) { const img = document.createElement('img'); img.src = payload.preview.image; img.alt = ''; thumb.append(img); }
    const info = document.createElement('div'); info.className = 'cart-item-info';
    const title = document.createElement('p'); title.textContent = payload.preview.title;
    const size = document.createElement('p'); size.textContent = payload.preview.size;
    const text = document.createElement('small'); text.className = 'pending-add-label'; text.textContent = 'Adding to your bag…';
    info.append(title, size, text); node.append(thumb, info); return node;
  };
  function paintPending() {
    const projected = projection();
    const busy = queue.busy || desynced;
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = projected.count; });
    for (const view of views()) {
      view.classList.toggle('is-busy', busy);
      view.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = busy; button.setAttribute('aria-busy', String(busy)); });
      const label = view.querySelector('[data-subtotal-label]');
      if (label) label.textContent = queue.busy ? 'Updating subtotal…' : 'Subtotal';
      const total = view.querySelector('[data-cart-total]');
      if (total && queue.busy) total.textContent = money(projected.total) + ' ' + cart.currency;
      view.querySelector('[data-cart-activity]').textContent = queue.busy ? 'Updating your bag…' : '';
      const empty = view.querySelector('[data-cart-empty]'); if (empty) empty.hidden = projected.count > 0;
      const pending = view.querySelector('[data-pending-adds]');
      const pendingTasks = projected.adds.filter(task => !cart.items.some(item => identity(item) === task.payload.identity));
      const desiredIds = pendingTasks.map(task => String(task.id));
      [...pending.children].forEach(node => { if (!desiredIds.includes(node.dataset.pendingId)) node.remove(); });
      pendingTasks.forEach(task => {
        if ([...pending.children].some(node => node.dataset.pendingId === String(task.id))) return;
        const node = pendingNode(task.payload); node.dataset.pendingId = task.id; pending.append(node);
      });
      for (const line of view.querySelectorAll('[data-cart-line-key]')) {
        const item = cart.items.find(item => item.key === line.dataset.cartLineKey);
        if (!item) continue;
        const quantity = projected.quantities.get(identity(item)) ?? item.quantity;
        const input = line.querySelector('[data-cart-quantity]'); input.value = quantity;
        line.classList.toggle('is-updating', quantity !== item.quantity);
        line.classList.toggle('is-removing', quantity === 0);
        line.querySelectorAll('[data-cart-adjust]').forEach(button => { button.disabled = quantity === 0; });
        const remove = line.querySelector('[data-cart-remove]'); remove.setAttribute('aria-disabled', String(quantity === 0));
        if (quantity !== item.quantity) line.querySelector('[data-line-price]').textContent = money(item.final_price * quantity);
      }
      const meter = view.querySelector('[data-shipping-meter]');
      if (meter) {
        const threshold = Number(meter.dataset.threshold);
        const amount = projected.adds.length ? cart.total_price : projected.total;
        const remaining = Math.max(0, threshold - amount);
        const percent = Math.max(0, Math.min(1, amount / threshold));
        meter.querySelector('[data-shipping-fill]').style.transform = `scaleX(${percent})`;
        meter.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.round(percent * 100));
        const complete = !busy && remaining === 0;
        meter.classList.toggle('is-complete', complete);
        meter.querySelector('[data-shipping-check]').textContent = complete ? '✓' : '↗';
        meter.querySelector('[data-shipping-message]').textContent = busy ? 'Updating free-shipping progress…' : remaining === 0 ? 'You’ve unlocked free US shipping.' : `Add ${money(remaining)} more for free US shipping.`;
      }
    }
  }
  const syncUpsells = (current, fresh) => {
    const oldTrack = current.querySelector('.recommendation-track');
    const newTrack = fresh.querySelector('.recommendation-track');
    if (!oldTrack || !newTrack) { current.innerHTML = fresh.innerHTML; return; }
    const currentCards = [...oldTrack.children];
    const freshCards = [...newTrack.children];
    const selected = new Map(currentCards.map(card => [card.dataset.recommendation, card.querySelector('select')?.value]));
    const sameProducts = currentCards.map(card => card.dataset.recommendation).join('|') === freshCards.map(card => card.dataset.recommendation).join('|');
    if (sameProducts) {
      freshCards.forEach((card, index) => {
        const previous = currentCards[index];
        const options = card.querySelectorAll('option');
        previous.querySelectorAll('option').forEach((option, i) => { if (options[i]) { option.disabled = options[i].disabled; option.textContent = options[i].textContent; } });
        const select = previous.querySelector('select');
        if (select?.selectedOptions[0]?.disabled) select.value = '';
        previous.querySelector('.recommendation-price').textContent = card.querySelector('.recommendation-price').textContent;
        previous.querySelector('.recommendation-reason').textContent = card.querySelector('.recommendation-reason').textContent;
      });
      current.querySelector('h3').textContent = fresh.querySelector('h3').textContent;
    } else {
      const offset = oldTrack.scrollLeft;
      current.innerHTML = fresh.innerHTML;
      current.querySelectorAll('.cart-recommendation').forEach(card => {
        const value = selected.get(card.dataset.recommendation);
        const select = card.querySelector('select');
        if ([...select.options].some(option => option.value === value && !option.disabled)) select.value = value;
      });
      current.querySelector('.recommendation-track').scrollLeft = offset;
    }
  };
  const applySection = markup => {
    const template = document.createElement('template'); template.innerHTML = markup;
    const fresh = template.content.querySelector('[data-cart-view]');
    if (!fresh) throw new Error('Your bag changed. Please open the bag page to review it.');
    const next = readState(fresh);
    const before = cart;
    for (const view of views()) {
      const lines = view.querySelector('[data-cart-lines]');
      const oldLines = new Map([...lines.children].map(line => {
        const item = before.items.find(item => item.key === line.dataset.cartLineKey);
        return [item ? identity(item) : line.dataset.cartLineKey, line];
      }));
      let cursor = lines.firstElementChild;
      for (const incoming of fresh.querySelector('[data-cart-lines]').children) {
        const item = next.items.find(item => item.key === incoming.dataset.cartLineKey);
        const key = identity(item);
        let line = oldLines.get(key);
        if (line) {
          oldLines.delete(key);
          line.dataset.cartLineKey = incoming.dataset.cartLineKey;
          for (const selector of ['[data-line-price]', '[data-line-discounts]']) line.querySelector(selector).innerHTML = incoming.querySelector(selector).innerHTML;
          line.querySelector('[data-cart-quantity]').dataset.key = item.key;
          line.querySelector('input[name="id"]').value = item.key;
          const remove = line.querySelector('[data-cart-remove]'); remove.dataset.key = item.key; remove.href = incoming.querySelector('[data-cart-remove]').href;
        } else { line = incoming.cloneNode(true); line.classList.add('is-new'); }
        if (line !== cursor) lines.insertBefore(line, cursor);
        cursor = line.nextElementSibling;
      }
      oldLines.forEach(line => line.remove());
      const empty = view.querySelector('[data-cart-empty]'); empty.hidden = next.item_count > 0;
      syncUpsells(view.querySelector('[data-cart-upsells]'), fresh.querySelector('[data-cart-upsells]'));
      const summary = view.querySelector('[data-cart-summary]');
      summary.innerHTML = fresh.querySelector('[data-cart-summary]').innerHTML;
      summary.hidden = next.item_count === 0;
      const meter = view.querySelector('[data-shipping-meter]');
      const nextMeter = fresh.querySelector('[data-shipping-meter]');
      if (!nextMeter && meter) meter.remove();
      else if (nextMeter && !meter) view.prepend(nextMeter.cloneNode(true));
      view.querySelector('[data-cart-state]').textContent = JSON.stringify(next);
    }
    cart = next; lastSync = Date.now(); desynced = false;
    paintPending();
    // Existing Shopify app pixels own analytics; no manual purchase/add events.
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  };
  const refreshCart = () => {
    if (refreshing) return refreshing;
    refreshing = api('?sections=mimi-cart-drawer').then(sections => {
      if (!sections['mimi-cart-drawer']) throw new Error('Please open your bag to review your items.');
      applySection(sections['mimi-cart-drawer']);
    }).finally(() => { refreshing = null; });
    return refreshing;
  };
  const finishAdd = payload => {
    delete payload.form.dataset.busy;
    payload.button?.removeAttribute('aria-busy');
    if (payload.button) payload.button.disabled = false;
  };
  const queue = new window.MimiCartQueue({
    onChange: paintPending,
    perform: async task => {
      const started = performance.now();
      let result;
      try {
        if (refreshing) await refreshing;
        if (task.kind === 'add') {
          const data = task.payload.data;
          data.set('sections', 'mimi-cart-drawer'); data.set('sections_url', window.location.pathname);
          result = await api('cart/add.js', { method: 'POST', body: data });
        } else {
          const item = cart.items.find(item => identity(item) === task.identity);
          if (!item) return;
          result = await api('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: task.quantity, sections: ['mimi-cart-drawer'], sections_url: window.location.pathname }) });
        }
        task.committed = true;
        // The updated markup and cart state arrive with the mutation itself.
        if (result.sections?.['mimi-cart-drawer']) applySection(result.sections['mimi-cart-drawer']);
        else await refreshCart();
        say(task.kind === 'add' ? 'Added to your bag.' : 'Bag updated.');
      } finally {
        views().forEach(view => { view.dataset.lastCartDuration = Math.round(performance.now() - started); });
        if (task.kind === 'add') finishAdd(task.payload);
      }
    },
    onError: async (error, task) => {
      // Never repeat a mutation after an uncertain response: first reconcile.
      try { await refreshCart(); }
      catch { desynced = true; }
      showError(error.message, desynced);
      const errorNode = task.payload?.form.querySelector('[data-form-error]');
      if (errorNode?.isConnected) errorNode.textContent = error.message;
    }
  });
  const setQuantity = (input, quantity) => {
    const item = cart.items.find(item => item.key === input.dataset.key);
    if (!item || !Number.isInteger(quantity) || quantity < 0) return;
    clearErrors(); queue.change(identity(item), quantity);
  };
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-close-dialog]'); if (close) closeDialog(close.closest('dialog'));
    const trigger = event.target.closest('[data-open-dialog]'); if (trigger) openDialog(trigger.dataset.openDialog, trigger);
    const menu = event.target.closest('.menu-toggle');
    if (menu) {
      const nav = document.getElementById('main-navigation');
      const opened = nav.classList.toggle('is-open'); menu.setAttribute('aria-expanded', String(opened));
    }
    if (event.target.closest('#main-navigation a')) {
      document.getElementById('main-navigation')?.classList.remove('is-open'); document.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'false');
    }
    const bag = event.target.closest('[data-open-cart]');
    if (bag && drawer?.showModal) {
      event.preventDefault(); openDialog('cart-drawer', bag);
      if (!queue.busy && (desynced || Date.now() - lastSync > 20000)) refreshCart().catch(() => showError('Could not refresh your bag.', true));
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      if (remove.getAttribute('aria-disabled') !== 'true') setQuantity(remove.closest('.cart-item').querySelector('[data-cart-quantity]'), 0);
    }
    const adjust = event.target.closest('[data-cart-adjust]');
    if (adjust) {
      const input = adjust.closest('[data-quantity-form]').querySelector('[data-cart-quantity]');
      setQuantity(input, Math.max(0, Number(input.value) + Number(adjust.dataset.cartAdjust)));
    }
    const stickyBuy = event.target.closest('[data-sticky-buy]');
    if (stickyBuy) {
      const form = document.getElementById(stickyBuy.dataset.formId);
      if (!form?.querySelector('input[name="id"]:checked')) {
        form?.querySelector('.size-fieldset')?.scrollIntoView({ block: 'center', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        form?.querySelector('input[name="id"]:not(:disabled)')?.focus({ preventScroll: true }); say('Choose an available size first.');
      } else form.requestSubmit(form.querySelector('button[type="submit"]'));
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.getElementById('main-navigation')?.classList.remove('is-open'); document.querySelector('.menu-toggle')?.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('.size-option input')) {
      const panel = input.closest('[data-product-section]');
      panel.querySelector('[data-selected-size]').textContent = input.dataset.size;
      panel.querySelector('[data-product-price]').textContent = input.dataset.price;
      const dispatchNote = panel.querySelector('[data-dispatch-note]');
      const dispatchDetail = panel.querySelector('[data-dispatch-detail]');
      const dispatchReady = input.dataset.dispatchReady === 'true';
      if (dispatchNote) dispatchNote.hidden = !dispatchReady;
      if (dispatchDetail) dispatchDetail.textContent = dispatchReady ? 'Ships in 2–3 business days.' : 'Dispatch timing is confirmed before purchase.';
      const stickyLabel = document.querySelector('[data-sticky-label]'); const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyLabel) stickyLabel.textContent = 'Add to bag'; if (stickyPrice) stickyPrice.textContent = input.dataset.price;
      const url = new URL(window.location.href); url.searchParams.set('variant', input.value); window.history.replaceState({}, '', url);
    }
    if (input.matches('[data-cart-quantity]')) {
      if (input.checkValidity()) setQuantity(input, Number(input.value)); else input.reportValidity();
    }
  });
  document.addEventListener('submit', event => {
    const quantityForm = event.target.closest('[data-quantity-form]');
    if (quantityForm) {
      event.preventDefault(); const input = quantityForm.querySelector('[data-cart-quantity]');
      if (input.checkValidity()) setQuantity(input, Number(input.value)); return;
    }
    if (event.submitter?.name === 'checkout' && queue.busy) { event.preventDefault(); say('Finishing your bag update.'); return; }
    const form = event.target.closest('[data-product-form]'); if (!form || !window.fetch) return;
    // Keep the native form as a fallback for browsers without the cart module.
    if (!drawer?.showModal) return;
    event.preventDefault();
    if (form.dataset.busy) return;
    const error = form.querySelector('[data-form-error]'); if (error) error.textContent = '';
    const data = new FormData(form); if (event.submitter?.name === 'id') data.set('id', event.submitter.value);
    if (!data.get('id')) {
      if (error) error.textContent = 'Choose an available size first.';
      form.querySelector('input[name="id"]:not(:disabled),select[name="id"]')?.focus(); return;
    }
    clearErrors();
    const scope = form.closest('.product-card,[data-product-section],.cart-recommendation');
    const selected = form.querySelector('.size-option input:checked');
    const size = selected?.dataset.size || form.querySelector('select')?.selectedOptions[0]?.textContent || event.submitter?.querySelector('span')?.textContent || '';
    const title = scope?.querySelector('.product-card-meta a,h1,.recommendation-title')?.textContent || 'Your jersey';
    const image = scope?.querySelector('.product-card-image img,.primary-image img,.recommendation-image img');
    const properties = {};
    for (const [key, value] of data) { const match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value; }
    form.dataset.busy = 'true'; const button = event.submitter; if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    openDialog('cart-drawer', button);
    const quantity = Math.max(1, Number(data.get('quantity')) || 1);
    queue.add({ form, button, data, quantity, identity: identity({ id: Number(data.get('id')), properties, selling_plan_id: Number(data.get('selling_plan')) || 0 }), preview: { title, size, image: image?.currentSrc || image?.src || '' } });
  });
  window.addEventListener('pageshow', event => { if (event.persisted && !queue.busy) refreshCart().catch(() => showError('Please refresh your bag.', true)); });
  document.addEventListener('shopify:section:load', () => document.getElementById('main-navigation')?.classList.remove('is-open'));
  paintPending();
})();
